/** 
 * ████████╗██╗  ██╗██████╗ ███████╗ █████╗ ██████╗      ██████╗██████╗ ███╗   ███╗
 * ╚══██╔══╝██║  ██║██╔══██╗██╔════╝██╔══██╗██╔══██╗    ██╔════╝██╔══██╗████╗ ████║
 *    ██║   ███████║██████╔╝█████╗  ███████║██║  ██║    ██║     ██████╔╝██╔████╔██║
 *    ██║   ██╔══██║██╔══██╗██╔══╝  ██╔══██║██║  ██║    ██║     ██╔══██╗██║╚██╔╝██║
 *    ██║   ██║  ██║██║  ██║███████╗██║  ██║██████╔╝██╗ ╚██████╗██║  ██║██║ ╚═╝ ██║
 *    ╚═╝   ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝╚═════╝ ╚═╝  ╚═════╝╚═╝  ╚═╝╚═╝     ╚═╝
*/
import 'reflect-metadata';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { logo } from './app/core/constants/logo';

console.log(logo);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
